import axios from '@/helpers/axios'

/**
 * 标签API
 */
export default {
  /**
   * 获取某一分类的标签列表
   *
   * @param {object} query 查询
   * @param {!string} query.category 分类
   * @returns {Promise<object>} 格式 { tags: [] }
   */
  getEntities(query) {
    return axios.get('/backend/tags', { params: query })
  },

  /**
   * 创建标签
   *
   * @param {object} params 参数
   * @param {string} params.name 标签名
   * @param {string} params.category 分类
   * @param {string} params.service_provider_id 所属运营商
   * @returns {Promise<object>} 格式 { id, name }
   */
  createEntity(params) {
    return axios.post(`/backend/tags`, params)
  }
}
